/**
 * React Query hook for the image-model capability contract (Phase 3).
 *
 * Loads + version-asserts the contract via ImageCapabilities.load(). A version
 * mismatch throws (fail loud, spec §4.4) and surfaces as query.error.
 */
import { useQuery } from '@tanstack/react-query';

import { ImageCapabilities } from './imageCapabilities';

export function useImageCapabilities() {
  return useQuery({
    queryKey: ['image-capabilities', 'contract'] as const,
    queryFn: () => ImageCapabilities.load(),
    staleTime: 10 * 60 * 1000,
  });
}
